import { isStaging } from '@/core/utilities';

export default class TwoFactorAuthService {
  /** @ngInject **/
  constructor(
    $http,
    ngAuthSettings,
  ) {
    this.$http = $http;
    this.ngAuthSettings = ngAuthSettings;    
    this.serviceBaseUri = ngAuthSettings.apiServiceBaseUri;
  }

  getTwoFactorMethods() {
    if (isStaging) {
      return import(/* webpackChunkName: "staging" */ './MockServices/MockTwoFactorAuthService').then(function ({ default: mockTwoFactorAuthService }) {
        return mockTwoFactorAuthService.getTwoFactorMethods();
      });
    }
    return this.$http.get(this.#serviceMfaBaseUrl('methods'));
  }

  getMFASettings() {
    if (isStaging) {
      return import(/* webpackChunkName: "staging" */ './MockServices/MockTwoFactorAuthService').then(function ({ default: mockTwoFactorAuthService }) {
        return mockTwoFactorAuthService.getMFASettings();
      });
    }
    return this.$http.get(this.#serviceMfaBaseUrl());
  }

  disableMFA() {
    if (isStaging) {
      return import(/* webpackChunkName: "staging" */ './MockServices/MockTwoFactorAuthService').then(function ({ default: mockTwoFactorAuthService }) {
        return mockTwoFactorAuthService.disableMFA();
      });
    }
    return this.$http.delete(this.#serviceMfaBaseUrl());
  }

  enableMFA(MFAModel) {
    if (isStaging) {
      return import(/* webpackChunkName: "staging" */ './MockServices/MockTwoFactorAuthService').then(function ({ default: mockTwoFactorAuthService }) {
        return mockTwoFactorAuthService.enableMFA(MFAModel);
      });
    }
    return this.$http.put(this.#serviceMfaBaseUrl(), MFAModel);
  }

  #serviceMfaBaseUrl(path) {
    const url = `${this.serviceBaseUri}Account/mfa/`;
    if (path) {
      return url + path;
    }
    return url;
  }
}